import React, { Component } from 'react';
import './edit-teacher.scss';
import SchoolProfile from '../../school/add-school/add-school'
import Loading from '../../common/loading/loading';
import { ImageConstants } from '../../../constants/constants';
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component';
import { getImageSource } from '../../../utility/image-source'
import Rewards from '../../reward/reward';
import Path from '../../routes/routes-path';
import RewardApi from '../../../apis/rewards';
import CommonUtils from '../../../utility/common-utilities';
import EditTeaacherProfile from '../edit-teacher-profile/edit-teacher-profile';
import SessionCache from '../../routes/session-cache';
import SchoolApi from '../../../apis/school';



class Profile extends Component {
    state = {
        // loading: false,
        classes: [],
        boards: []
    }

    constructor(props) {
        super(props)
        let urlParams = new URLSearchParams(window.location.search);

        let type = urlParams.get('type')

        let user = SessionCache.getUser()
        this.userInfo = user

        if (type) this.state.showReward = true
        this.getStaffs()
        this.getClasses()
    }

    componentDidMount() {
        this.getReward()
    }

    getStaffs(payload = {}) {

        payload = {
            userId: this.userInfo.id
        }

        payload.getClassDetails = true

        this.setState({ loading: true })

        SchoolApi.getStaffs(payload)
            .then(response => {
                console.log(response)

                let selectedUser = response.response[0]

                console.log(selectedUser)

                this.setState({
                    selectedUser,
                    loading: false
                })
            }).catch(err => {
            })

    }

    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = []
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }
                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }
                const board = boards[0].value
                this.setState({ classes, boards, board }, _ => {
                    // if (this.props?.location?.showAddTeacher) {
                    //     this.setState({
                    //         showAddContactModal: true,
                    //         mode: "CREATE"
                    //     })
                    //     this.props.location.showAddTeacher = false
                    // }
                })
            }).catch(err => {
            })
    }

    getReward(payload = {}) {
        RewardApi.getRewardPoints(payload)
            .then(response => {
                let reward = response.response
                this.setState({ reward: reward, isLoading: false })
            }).catch(err => {
                this.setState({ isLoading: false })
            })
    }

    onSaveSchool = () => {
        this.showToaster("success", "Profile Updated Successfully")
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 3000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }

    onClickReward = (e, back) => {
        if (back === "BACK") {
            //this.setState({ showReward: !this.state.showReward })
            // window.location.replace("https://www.example.com");
            this.props.history.push(Path.DASHBOARD)

        }
        else {
            this.setState({ showReward: !this.state.showReward })
        }
    }

    render() {

        if (this.state.showReward) return <Rewards back={e => this.onClickReward(e, "BACK")} />

        return (
            <div className="profile">
                {this.state.loading && <Loading />}
                <div className="">
                    {
                        this.state.selectedUser ? <span className='screen-title'>EDIT TEACHER PROFILE</span>
                            :
                            <span className='screen-title'>SCHOOL PROFILE</span>
                    }

                    <div className="text-right">
                        <img alt="" src={getImageSource(ImageConstants.GRAPHIC1)} className='image-top' />
                    </div>
                </div>
                <div className="row pt-4">
                    <div className="col profile-card">
                        <div className="cw-card px-5 py-4">

                            {
                                this.state.selectedUser ?
                                    <EditTeaacherProfile hideDefaultType
                                        mode={"EDIT"}
                                        selectedUser={this.state.selectedUser}
                                        classes={this.state.classes}
                                        boards={this.state.boards} />
                                    :
                                    <SchoolProfile disableBack disableHeader school={this.state.selectedSchool} onSave={this.onSaveSchool} />
                            }

                        </div>
                    </div>
                    <div className="col">
                        <div className="text-right">
                            <div className="cw-card cursor-pointer custom-card d-inline-block py-2 px-4" onClick={this.onClickReward}>
                                <img alt="" src={getImageSource(ImageConstants.GIFTBOX)} className='mr-2' />
                                <span className='reward-text'>My Reward Points</span> <span className="reward-point"> {CommonUtils.convertToFixed(this.state.reward?.availablePoints || 0, 2)}</span>
                            </div>
                        </div>
                        <div className="text-center pt-5 mt-5">
                            <img alt="" src={getImageSource(ImageConstants.PROFILE_VECTOR)} className='profile-vector-img' />
                        </div>

                        <div className="text-right px-0">
                            <img alt="" src={getImageSource(ImageConstants.GRAPHIC2)} className='image-buttom' />
                        </div>
                    </div>
                </div>
                {this.state.showToaster ? <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} /> : ""}
            </div>);
    }
}

export default Profile;